import styled from "styled-components";

export const Items = styled.div`
    padding: 40px 10px 40px 10px;
    border-bottom: 1px solid #999;

    img {
        vertical-align: top;
    }
    .inner {
        display: table;
        width: 100%;
        table-layout: fixed;

        .img_area,
        .info_area {
            position: relative;
            display: table-cell;
            vertical-align: top;
        }
        .img_area {
            width: 144px;
        }
        .info_area {
            padding: 0 0 0 25px;

            .title {
                overflow: hidden;
                max-height: 58px;
                margin-bottom: 8px;
                line-height: 29px;
                font-size: 20px;
                padding: 0 10px 0 0;

                .link  {
                    font-weight: 700;
                    color: #191919;
                    word-break: break-all;

                    &:hover {
                        text-decoration: underline
                    }
                }
                .highlight {
                    padding: 0 4px;
                    color: #fff;
                    font-style: normal;
                    background: #f34522
                }
            }
            .layout_trans {
                margin-bottom: 16px;
            }
            .price_area {
                margin: 0 0 16px;
                display : flex;
                flex-direction: row;
                align-items: center;

                .price {
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;

                    span {
                        color: #999;
                    }
                    .no_price {
                        font-size: 20px;
                        font-weight: 700;
                    }
                    .num {
                        font-size: 20px;
                        font-weight: 700;
                        color: #f24443;
                    }
                }
                .link {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 0 0 11px;
                    background: #418ded;
                    color: #fff;
                    font-size: 12px;
                    line-height: 20px;
                    padding: 0 13px;
                    height: 20px;
                }
            }
            .depth {
                margin-bottom: 0;
                line-height: 18px;
                vertical-align: top;

                .category {
                    display: inline-block;
                    color: #999;
                    vertical-align: top;

                    & ~ .category {
                            &:before {
                            display: inline-block;
                            margin: 0 4px;
                            color: #999;
                            content: ">";
                        }
                    }
                }
            }
            .desc {
                .detail_box {
                    overflow: hidden;
                    padding: 0 10px 0 0;
                    max-height: 54px;
                    margin-bottom: 24px;
                    vertical-align: top;

                    .detail {
                        color: #666;
                        display: inline-block;
                        line-height: 18px;

                        &:not(:last-child):after {
                            content: '';
                            display: inline-block;
                            width: 1px;
                            height: 7px;
                            background: #999;
                            margin: 0 5px;
                        }
                        &:hover {
                            text-decoration: underline
                        }
                        &.active {
                            color: #418ded
                        }
                    }
                }
            }
            .subinfo {
                margin-bottom: 8px;

                .special {
                    color: #FF9900;
                }
            }
            .etc_box {
                position: relative;

                .etc {
                    display: inline-block;
                    line-height: 18px;
                    color: #999;
                    vertical-align: top;

                    & ~ .etc:before {
                        content: '';
                        display: inline-block;
                        width: 1px;
                        height: 7px;
                        background: #999;
                        margin: 0 8px;
                    }
                }
                .graph,
                .star {
                    background-image: ${`url(${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/sprite_1.png)`};
                    width: 85px;
                    height: 13px;
                    display: inline-block;
                    vertical-align: top;
                }
                .graph {
                    background-position: -344px -172px;
                    margin: 2px 0 0 3px;
                }
                .star {
                    background-position: -344px -185px;
                    overflow: hidden;
                    color: transparent;
                    cursor: default;
                }
                .num {
                    margin-left: 4px;
                    color: #418ded;
                    font-style: normal;
                }
                .button.zzim {
                    border: 0;
                    background: transparent;
                    color: #418ded;

                    span {
                        color: #999
                    }
                    &.active {
                        span {
                            color: #418ded;
                        }
                        i:before {
                            content: "\\e918"
                        }
                    }
                    i {
                        &:before {
                            position: relative;
                            top: 1px;
                            margin: 0 3px 0 0;
                            display: inline-block;
                            transform: scale(1.1);
                        }
                    }
                }
                .reportWrap {
                    display: inline-block;
                    vertical-align: top;

                    & > img.btn_report {
                        width: 18px;
                        height: 18px;
                    }
                    .PopMain.artPop {
                        strong {
                            color: #333
                        }
                    }
                }
                .btn_report {
                    border: 0;
                    background: transparent;
                    color: #999;
                }
                .medium_txt {
                    margin: 0 0 0 4px;
                }
            }
        }
    }
    &.thumb {
        /* 썸네일모드 css */
        padding: 0;
        margin-right: 25px;
        //width: 300px;
        width: ${(props) => props.domain === 'shopping' ? '300' : '280'}px;
        vertical-align: top;
        display: inline-block;
        border-bottom: 0;

        .inner {
            margin-bottom: ${(props) => props.domain === 'shopping' ? '0' : '20'}px;
            .img_area,
            .info_area {
                display: block;
            }
            .img_area {
                width: auto;
                padding: 0;
                min-height: 200px;
            }
            .info_area {
                padding-left: 0;
                padding-bottom: 54px; /* 가격 표시 높이*/

                .layout_trans {
                    margin-bottom: 0
                }
                .price_area {
                    position: absolute;
                    bottom: 0;

                    .price {
                        font-size: 16px;

                        span {
                            color: #666
                        }
                        .num {
                            color: #f24443
                        }
                    }
                }
                .subinfo {
                    display: none
                }
                .depth {
                    margin-bottom: 0;
                }
            }
            .title {
                padding: 8px 10px 0 0;
                margin-bottom: 10px;
                font-size: 18px;
                line-height: 28px;
                height: 64px;
                max-height: 64px;
            }
        }
        .thumbnail_thumb {
            width: auto;
            height: auto;

            & > div {
                width: ${(props) => props.domain === 'shopping' ? '298' : '278'}px;
                height: ${(props) => props.domain === 'shopping' ? '298' : '278'}px;
                //width:  298px;
                //height: 298px;
            }
        }
        .top_label {
            margin: 10px 0 0;
            height: 21px;
        }
        .thumb_under_btn {
            display: flex;
            justify-content: space-between;

            .button {
                flex: 1 0 auto;
                height: 30px;
                line-height: 28px;
                text-align: center;
                border: 1px solid #b5b5b5;
                color: #666;
                font-size: 14px;

                &:hover {
                    background: #f7f7fa;
                }
                &.more {
                    margin: 0 2px 0 0;

                    i {
                        position: relative;
                        top: 1px;
                    }
                    &.active {
                        background: #f7f7fa;
                    }
                }
                &.zzim {
                    &.active {
                        border-color : #418ded;
                        background: #418ded;
                        color: #fff;
                    }
                    i {
                        position: relative;
                        top: 1px;
                    }
                }
            }
        }
    }
    &.pc {
        .inner {
            .info_area {
                .title {
                    margin-bottom: 15px;
                    padding-right: 0;
                }
                .layout_trans {
                    display: flex;
                    justify-content: space-between;
                }
                .layout_trans2 {
                    order: 1;
                }
                .price_area {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0;
                    order: 2;

                    .price {
                        .num {
                            font-size: 32px;
                        }
                    }
                    .estimate_group_btns {
                        display: flex;
                        align-items: center;
                        position: relative;
                        width: 101px;
                        height: 38px;
                        &.small {
                            width: 45px;
                        }
                        &.sold_out {
                            width: 64px;
                        }
                        &.compare {
                            width: 76px;
                        }
                        .estimate_add_btn {
                            position: absolute;
                            top: 7px;
                            right: calc(100% - 37px);
                            margin: 0 0 0 10px;
                        }
                        .mall_count{
                        width : 36px;
                        height : 16px;
                        font-size : 12px;
                        text-align : right;
                        letter-spacing: -0.66px;
                        line-height: 18px;
                        color : #999999;
                        margin-left : 39px;
                            &.sold_out {
                                margin-left: 0;
                            }
                        }
                    }
                }
            }
        }
        &.thumb {
            .inner {
                .info_area {
                    .layout_trans {
                        flex-direction: column;
                        margin-bottom: 0;
                    }
                }
                .price_area {
                    .price {
                        .num {
                            font-size: 26px;
                        }
                    }
                }
            }
        }
    }
    .thumbnail_thumb {
        width: 144px;
        height: 144px;
        display: block;
        border: 1px solid #efeff3;
        :hover{
            border: 1px solid #418DED;
        }
    }
    .full_width {
        width: 100%;
        height: auto
    }
`

export const WrapperCutationEstimate = styled.div`
    position: relative;
    margin-left: 10px;
    width: 27px;
    height: 27px;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item.style.js